import { useCallback } from 'react';
import { useChartSettingsStore } from './store';
import { ChartStyle } from './types';

type ColorScheme = "blackOnWhite" | "greenOnBlack" | "colorOnWhite";

export const initializeChartSettingsStore = () => {
  const { loadChartSettings } = useChartSettingsStore.getState();
  loadChartSettings();
};

export const useSetScheme = () => {
  const { updateMultipleChartSettingsStyle } = useChartSettingsStore();

  const setScheme = useCallback((scheme: ColorScheme) => {
    let schemeColors: Partial<ChartStyle>;

    switch (scheme) {
      case "blackOnWhite":
        schemeColors = {
          scheme: "blackOnWhite",
          foreground: "#FFFFFF",  // White text
          grid: "#F0F0F0",       // Very light gray
          barUp: "#000000",      // Black bars for up
          barDown: "#808080",    // Gray bars for down
          bullCandle: "#FFFFFF", // White candle for up
          bearCandle: "#000000", // Black candle for down
          lineChart: "#FFFFFF",  // White line
          volumes: "#00FF00",    // Green volumes
          bidPriceLine: "#0000CD", // Dark blue
          askPriceLine: "#FF0000", // Red
          stopsLevels: "#FFA500",  // Orange
        };
        break;

      case "greenOnBlack":
        schemeColors = {
          scheme: "greenOnBlack",
          foreground: "#FFFFFF",  // White text
          grid: "#808080",       // Gray grid  
          barUp: "#00FF00",      // Bright green bars up
          barDown: "#008000",    // Dark green bars down
          bullCandle: "#000000", // Black candle for up
          bearCandle: "#FFFFFF", // White candle for down
          lineChart: "#00FF00",  // Green line
          volumes: "#00FF00",    // Green volumes
          bidPriceLine: "#808080", // Gray bid line
          askPriceLine: "#FF0000", // Red ask line
          stopsLevels: "#FF0000",  // Red stop levels
        };
        break;

      case "colorOnWhite":
        schemeColors = {
          scheme: "colorOnWhite",
          foreground: "#FFFFFF",      // White text
          grid: "#333333",           // Dark gray grid
          barUp: "#2E8B57",          // Dark sea green (pastel turquoise)
          barDown: "#CD5C5C",        // Indian red (pastel red)
          bullCandle: "#2E8B57",     // Dark sea green (pastel turquoise)
          bearCandle: "#CD5C5C",     // Indian red (pastel red)
          lineChart: "#32CD32",      // Lime green (grass-like)
          volumes: "#2E8B57",        // Dark sea green (pastel turquoise)
          bidPriceLine: "#2E8B57",   // Dark sea green (pastel turquoise)
          askPriceLine: "#CD5C5C",   // Indian red (pastel red)
          stopsLevels: "#FF0000",    // Red
        };
        break;

      default:
        schemeColors = {
          scheme: "blackOnWhite",
          foreground: "#000000",  // Black text on white background
          grid: "#E0E0E0",
          barUp: "#26a69a",       // Teal bars for up
          barDown: "#ef5350",     // Red bars for down
          bullCandle: "#FFFFFF",  // White/hollow candle for up (traditional)
          bearCandle: "#000000",  // Black/filled candle for down (traditional)
          lineChart: "#000000",
          volumes: "#808080",
          bidPriceLine: "#2196F3",
          askPriceLine: "#FF0000",
          stopsLevels: "#FF6600",
        };
        break;
    }

    updateMultipleChartSettingsStyle(schemeColors);
  }, [updateMultipleChartSettingsStyle]);

  return setScheme;
};